import { render } from "./uploadfile.vue?vue&type=template&id=1c80bb43"
import script from "./uploadfile.vue?vue&type=script&lang=js"
export * from "./uploadfile.vue?vue&type=script&lang=js"

import "./uploadfile.vue?vue&type=style&index=0&id=1c80bb43&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__